module.exports = __webpack_public_path__ + "static/img/index_021.e0a2df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_021.png
// module id = +LLy
// module chunks = 1